import React, { Component } from 'react';
import { connect } from 'react-redux';
import CompareButton from '../Components/CompareButton';
import {
  add,
  showCompareButtonErrorAction,
} from '../Actions/ComparedProduct.action';

class CompareButtonContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <CompareButton
        {...this.props}
        onClick={(productId) => this.props.add(productId)}
        showCompareButtonError={this.props.showCompareButtonError}
        showCompareButtonErrorAction={(value) =>
          this.props.showCompareButtonErrorAction(value)
        }
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    comparedProducts: state.comparedProducts.list,
    showCompareButtonError: state.comparedProducts.showCompareButtonError,
    errors: state.comparedProducts.errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (ProductNumber) => dispatch(add(ProductNumber)),
    showCompareButtonErrorAction: (value) =>
      dispatch(showCompareButtonErrorAction(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompareButtonContainer);
